const ITEMS = [
  "PRECISÃO MILIMÉTRICA",
  "TECNOLOGIA RTK GNSS",
  "MAPEAMENTO COM DRONES",
  "ESTAÇÕES TOTAIS",
  "CERTIFICAÇÃO INCRA",
  "CONSTRUÇÃO CIVIL",
  "AGRONEGÓCIO",
  "REGULARIZAÇÃO FUNDIÁRIA",
  "FORTALEZA — CE",
];

const Diamond = () => (
  <svg width="9" height="9" viewBox="0 0 12 12" className="shrink-0 text-dm-contour/70">
    <path d="M6 0L12 6 6 12 0 6z" fill="currentColor" />
  </svg>
);

export default function Marquee() {
  return (
    <div className="relative border-y border-white/[0.07] bg-deep/70 py-5 overflow-hidden">
      <div className="flex w-max animate-marquee items-center gap-10 pr-10 hover:[animation-play-state:paused]">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center gap-10" aria-hidden={copy === 1}>
            {ITEMS.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center gap-10">
                <span className="font-mono text-xs tracking-[0.3em] text-slate-400 whitespace-nowrap">
                  {item}
                </span>
                <Diamond />
              </span>
            ))}
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
    </div>
  );
}
